<div class="sales-code">
  <div class="sales-code-header mb-0">
    <div class="ui-g-12 flex-between-center p-0">
      <div class="flex-start-center width-100p">
        <div class="width-100p p-relative font-600 font-16 mt-1">{{ isEditMode ? 'Edit' : 'Create' }} Sales Code</div>
      </div>
      <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="handleClose(isReqRefresh)"></i>
    </div>
  </div>
  <!-- body -->

  <div class="sales-code-body">
    <div class="ui-g-12 p-0 input-control-container">
      <!-- sales code permission description -->
      <div class="ui-g-12 p-0 flex-start-center p-3 mb-3 sales-code-permission" *ngIf="!canEditClassifications">
        <i class="fal fa-exclamation-triangle font-yellow pr-2"></i>
        <span class="font-bold">This data is read only: <span class="font-400">You do not have permission to modify Sales Codes. Reach out to AutoLeap support if you need assistance.</span></span>
      </div>

      <!-- Sales code name -->
      <div class="ui-g-9 p-0 flex-start-center" [ngClass]="{ 'opacity-5': !canEditClassifications }">
        <div class="width-100p pr-2 primary-active-border">
          <div class="d-flex">
            <label class="label-heading font-13 font-600 pr-2">Sale Code Name</label>
            <div tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
              pTooltip="Enter a shortcut which can later be used to conveniently search this Sales Code">
              <i class="fal fa-info-circle"></i>
            </div>
          </div>

          <app-input id="sales-code-name" type="text" placeholder="Enter sales code name*" theme="border"
            [fontSize]="14" name="name" [autoFocus]="true" [value]="salesCode.title" [maxLength]="50" [disabled]="!canEditClassifications"
            (appChange)="handleChange('title', $event)">
          </app-input>
        </div>
      </div>

      <!-- Sales code shortcut -->
      <div class="p-0 ui-g-3 flex-start-center" [ngClass]="{ 'opacity-5': !canEditClassifications }">
        <div class="width-100p pl-1 pr-1 primary-active-border">
          <div class="d-flex">
            <label class="label-heading font-13 font-600 pr-2">Sale Code</label>
            <div tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
              [pTooltip]="'Enter a shortcut which can later be used to \n conveniently search this Sales Code'">
              <i class="fal fa-info-circle"></i>
            </div>
          </div>

          <app-input id="sales-code-shortcut" type="text" placeholder="Enter sales code" theme="border" [fontSize]="14"
            name="shortcut" [value]="salesCode.shortName" [maxLength]="10" [disabled]="!canEditClassifications"
            (appChange)="handleChange('shortName', $event)">
          </app-input>
        </div>
      </div>
    </div>
    <div class="ui-g-12 p-0 pt-2 input-control-container">
      <!-- Sales group -->
      <div class="p-0 flex-start-center sales-group-auto-complete">
        <div class="width-100p primary-active-border">
          <div class="d-flex">
            <label class="font-12 font-gray-700 font-600">Sales Group</label>
          </div>

          <app-auto-complete #salesGroupdDropdown id="ac-sales-category" listId="ac-sales-category-list"
            placeholder="Select group" field="name" scrollHeight="180px" theme="border" editableItemIdKey="_id"
            editFieldLabel="Create Sales Group" [hasCustomEditableField]="true" [disabled]="!canEditClassifications"
            [hasEditableField]="true" [hasFutureSelectionField]="false" [closeOnSelection]="true"
            [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false" [suggestions]="salesGroupsResults"
            [listItemFontSize]="14" [fontSize]="14" [value]="salesCode?.salesGroup?.name"
            (appSelect)="onSalesGroupSelect($event)" (appUpdateItem)="onSalesGroupUpdate($event)"
            (appChange)="onSalesGroupSelect($event)" (appCompletedMethod)="onSalesGroupSearch($event)"
            (appClear)="onClearSuggestion('salesGroup')">
            <ng-template let-item let-close let-editItem="editItem" appTemplate="item">
              <div class="tag-item flex-between-center">
                <div>{{ item?.name }}</div>
                <div class="tag-item-action flex-end-center">
                  <i *ngIf="item.isLoading" class="fal fa-spinner rotate mr-2"></i>
                  <i *ngIf="!item.isLoading" class="far fa-trash p-1 mr-2"
                    (click)="$event.stopPropagation(); handleDeleteSalesGroup(item)"></i>

                  <i class="far fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); onEditItem(item)"></i>
                </div>
              </div>
            </ng-template>

            <ng-template let-item appTemplate="editable">
              <div [ngClass]="isCreateNew ? (isMidasRoyaltyReportsEnable ? 'create-new-midas' : 'create-new') : ''">
                <div *ngIf="!isCreateNew" (click)="$event.stopPropagation(); isCreate(true)">Create Sales Group</div>
                <div *ngIf="isCreateNew" class="ui-g-12 p-0 font-gray">
                  <div class="ui-g-6">
                    <label class="font-12 font-gray-700 font-600" for="group-name">Sales Group Name</label>
                    <app-input placeholder="Enter group name" [isInvalid]="errors?.name"
                      styleClass="input-create-new-sale-code" theme="border" [fontSize]="12"
                      [value]="newSalesGroup?.name" (appFocus)="onFocus('name')"
                      (appChange)="handleChangeSalesCode('name', $event)"></app-input>
                  </div>
                  <div class="ui-g-6">
                    <label class="font-12 font-gray-700 font-600" for="group-name">Sales Group Code</label>
                    <app-input placeholder="Enter Code" [isInvalid]="errors?.groupCode"
                      styleClass="input-create-new-sale-code" theme="border" [fontSize]="12"
                      [value]="newSalesGroup?.groupCode" (appFocus)="onFocus('groupCode')"
                      (appChange)="handleChangeSalesCode('groupCode', $event)"></app-input>
                  </div>
                </div>

                <div *ngIf="isCreateNew && isMidasRoyaltyReportsEnable" class="ui-g-12 p-0 font-gray">
                  <div class="ui-g-6">
                    <label class="font-12 font-gray-700 font-600" for="group-name">M2 Sales Group Name</label>
                    <app-input placeholder="Enter group name" [isInvalid]="errors?.m2GroupName"
                      (appFocus)="onFocus('m2GroupName')" styleClass="input-create-new-sale-code" theme="border"
                      [fontSize]="12" [value]="newSalesGroup?.m2GroupName"
                      (appChange)="handleChangeSalesCode('m2GroupName', $event)"></app-input>
                  </div>
                  <div class="ui-g-6">
                    <label class="font-12 font-gray-700 font-600" for="group-name">M2 Sales Group Code</label>
                    <app-input placeholder="Enter Code" [isInvalid]="errors?.m2GroupCode"
                      (appFocus)="onFocus('m2GroupCode')" styleClass="input-create-new-sale-code" theme="border"
                      [fontSize]="12" [value]="newSalesGroup?.m2GroupCode"
                      (appChange)="handleChangeSalesCode('m2GroupCode', $event)"></app-input>
                  </div>
                </div>

                <div *ngIf="isCreateNew" class="ui-g-12 flex-between-end">
                  <div class="ui-g-6">&nbsp;</div>
                  <div class="ui-g-6">
                    <div class="d-flex justify-content-end">
                      <button [disabled]="loader.isSavingCode" id="sales-code-cancel-btn"
                        class="btn btn-white pointer btn-submit ml-2"
                        (click)="$event.stopPropagation(); isCreate(false)">Cancel</button>

                      <button id="sales-code-save-btn" class="btn btn-primary btn-submit pointer ml-2"
                        tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                        (click)="onSalesGroupCreate(close)">
                        <span class="font-bold">{{ isEditModeCode ? 'Save' : 'Create' }}</span>
                        <i *ngIf="loader.isSavingCode" class="fal fa-spinner rotate ml-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>
      </div>
    </div>

    <div *ngFor="let salesCode of salesCodes; let i = index" class="item-classification ui-g-12 p-0 mt-3"
      [hidden]="salesCode?.isDeleted || !salesCode?.itemType">
      <div class="px-2 pt-2">
        <div class="flex-between-center">
          <label class="label-heading font-13 font-500 font-gray-700">Item type</label>
          <span><i class="fal fa-trash p-1 mr-2 pointer" [ngClass]="{'not-allowed': !canEditClassifications}" (click)="canEditClassifications ? handleDeleteSalesCode(i) : ''"></i></span>
        </div>

        <div class="flex-start-center">
          <app-radio-button *ngFor="let itemType of itemTypes; let j = index" id="sales-item-type-{{ i }}"
            btnId="sales-item-type-{{ itemType.type }}-{{ i }}" class="pr-3" name="sales-item-type-{{ i }}"
            tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center" [label]="itemType.name"
            [selectedValue]="salesCode.itemType" [value]="itemType.type"
            [disabled]="(itemType.disabled && itemType.type !== salesCode.itemType) || !canEditClassifications"
            [styleClassLabel]="itemType.disabled && itemType.type !== salesCode.itemType ? 'opacity-5 font-seconday' : 'font-seconday'"
            [pTooltip]="itemType.disabled && itemType.type !== salesCode.itemType ? itemType.tooltip : ''"
            (appChange)="handleItemTypeChange($event, salesCode, i)">
          </app-radio-button>
        </div>
      </div>

      <div class="input-basic-info-wrapper input-default-style px-2 pt-3 ui-g">
        <div class="d-flex">
          <label class="label-heading font-13 font-500 font-gray-700 pr-2"> Search item classification(s) </label>
          <div tooltipPosition="top" tooltipStyleClass="tooltip-width-large text-center"
            pTooltip="Select a Category/Subcategory/Sub Item Type. This sales code will be applied to items that fall under the selected Item Type and are associated with the selected Category/Subcategory/Sub Item type.">
            <i class="fal fa-info-circle"></i>
          </div>
        </div>

        <div class="ui-g-12 p-0 input-control-container pb-2 primary-active-border">
          <app-auto-complete id="sales-code-category-dropdown" listId="sales-code-categorye-dropdown-list"
            placeholder="Search" field="name" scrollHeight="195px" theme="border" editableItemIdKey="_id"
            leftIcon="fal fa-search font-gray" inactiveItemsKey="isActive" [selectInactiveItems]="false"
            [isSetPositionDynamically[isSetPositionDynamically]="true" [value]="itemSearchQuery" [maxLength]="75"
            [hasFutureSelectionField]="false" [closeOnSelection]="true" [hasSearchIcon]="true"
            [isLoading]="isSearchingCategories" [isProgressiveLoading]="isPaginating" [disabled]="!canEditClassifications"
            [suggestions]="salesCode.categoriesResults" [listItemFontSize]="14" [fontSize]="14"
            (scroll)="searchCategories(categorySearchOptions.query, salesCode, categorySearchOptions.page + 1)"
            (appSelect)="onCategorySelect($event, salesCode)" (appClear)="searchCategories('', salesCode)"
            (appCompletedMethod)="searchCategories($event, salesCode)"
            (appChange)="handleChange('category', $event, salesCode)"
            (appClear)="onClearSuggestion('category', salesCode)">
            <ng-template let-item let-editItem="editItem" appTemplate="item">
              <div class="tag-item flex-between-center" tooltipPosition="top"
                tooltipStyleClass="tooltip-width-medium text-center"
                [ngClass]="{ 'not-allowed opacity-5': !item.isActive }" [escape]="false"
                [pTooltip]="!item.isActive ? item?.tooltipMsg : ''">
                <div>
                  <span [innerHTML]="getItemTitle(item) | highlighter : itemSearchQuery : 'partial'"></span>
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>

        <div class="pt-2 d-flex ui-g-12 p-0">
          <div class="label-heading font-13 font-500 font-gray-700 ui-g-5 p-0">Or select item classification manually
          </div>
          <div class="ui-g-7 p-0 mr-1" class="select-item-manually-label"></div>
        </div>

        <div class="ui-g-12 p-0">
          <div class="ui-g-11 p-0">
            <div class="ui-g-4 p-0 pr-2 primary-active-border">
              <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
                label="Standard Category" placeholder="Select top category" scrollHeight="186px" theme="border"
                [fontSize]="14" [listItemFontSize]="14" [listItemFontSize]="13" [isLoading]="loader.category"
                [suggestions]="salesCode.categoriesSuggestions" [disabled]="!canEditClassifications"
                [isSetPositionDynamically[isSetPositionDynamically]="true"
                [value]="salesCode.individualSearch?.category?.categoryName" [isDropdownIconVisible]="true"
                (appSelect)="categoryDropdownSelect('category', $event, salesCode)"
                (appCompletedMethod)="searchItem('category', $event, salesCode)"
                (appClear)="onClearSuggestion('individualCategory', salesCode)">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center" tooltipPosition="top">
                    {{ item.categoryName }}
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>

            <div class="ui-g-4 p-0 pr-2 primary-active-border">
              <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list" field="subCategoryName"
                placeholder="Select subcategory" scrollHeight="186px" theme="border" [fontSize]="14"
                [listItemFontSize]="14" [disabled]="!salesCode.individualSearch?.category?.categoryId || !canEditClassifications"
                [isLoading]="loader.subCategory" [value]="salesCode.individualSearch?.subCategory?.subCategoryName"
                [listItemFontSize]="13" [suggestions]="salesCode.subCategoriesSuggestions"
                [isSetPositionDynamically[isSetPositionDynamically]="true" [isDropdownIconVisible]="true"
                (appSelect)="categoryDropdownSelect('subCategory', $event, salesCode)"
                (appCompletedMethod)="searchItem('subCategory', $event, salesCode)"
                (appClear)="onClearSuggestion('subCategory', salesCode)">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center" tooltipPosition="top">
                    {{ item.subCategoryName }}
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>

            <div class="ui-g-4 p-0 primary-active-border">
              <app-auto-complete id="standard-part-type" listId="standard-part-type-list" field="subSubCategoryName"
                placeholder="Select sub item type" scrollHeight="186px" theme="border" inactiveItemsKey="isActive"
                [selectInactiveItems]="false" [fontSize]="14" [listItemFontSize]="14" [listItemFontSize]="13"
                [value]="salesCode.individualSearch?.subSubCategory?.subSubCategoryName"
                [disabled]="!salesCode.individualSearch?.subCategory?.subCategoryId || !canEditClassifications" [isLoading]="loader.subSubCategory"
                [suggestions]="salesCode.subSubCategoriesSuggestions" [isDropdownIconVisible]="true"
                (appSelect)="categoryDropdownSelect('subSubCategory', $event, salesCode)"
                (appCompletedMethod)="searchItem('subSubCategory', $event, salesCode)"
                (appClear)="onClearSuggestion('subSubCategory', salesCode)">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center" tooltipPosition="top"
                    tooltipStyleClass="tooltip-width-medium text-center"
                    [ngClass]="{ 'not-allowed opacity-5': !item.isActive }" [escape]="false"
                    [pTooltip]="!item.isActive ? item?.subSubtooltipMsg : ''">
                    <div>
                      <span>{{ item.subSubCategoryName }}</span>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <div class="ui-g-1 p-0 pl-2">
            <button id="sales-code-save-btn" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
              class="btn btn-white btn-add-type pointer" [escape]="false"
              [pTooltip]="salesCode?.isAddBtnDisabled ? salesCode?.btnTooltip : ''"
              [ngClass]="{ 'border-primary': salesCode.individualSearch?.category?.categoryId && !salesCode?.isAddBtnDisabled, 'not-allowed': !salesCode.individualSearch?.category?.categoryId || salesCode?.isAddBtnDisabled }"
              [disabled]="!salesCode.individualSearch?.category?.categoryId || salesCode?.isAddBtnDisabled || !canEditClassifications"
              (click)="addIndividualCategories(salesCode)">
              <span class="font-bold">Add</span>
            </button>
          </div>
        </div>

        <div class="ui-g-12 p-0 mt-2 flex-wrap" *ngIf="salesCode.salesCodeCategories?.length">
          <span *ngFor="let category of salesCode.salesCodeCategories; let itemIndex = index"
            class="classficiation-tag p-2 mr-2 d-flex mb-2">
            <span class="font-600">
              {{ getItemTitle(category, true) }}
            </span>
            <i class="pl-2 fal fa-times pointer align-self-center" [ngClass]="{'not-allowed': !canEditClassifications}"
              (click)="canEditClassifications ? removeCategoryItem(itemIndex, salesCode) : ''"></i>
          </span>
        </div>
      </div>
    </div>

    <div class="ui-g-12 p-0 mt-3">
      <button class="btn btn-sales-code" (click)="handleAddSalesCode()" [disabled]="!canEditClassifications"
        *ngIf="itemTypes?.length !== salesCodes?.length">
        <i class="fal fa-plus-circle mr-1"></i>
        <span class="font-14">Add another item type</span>
      </button>
    </div>
  </div>

  <!-- Star Footer -->
  <div class="ui-g-12 flex-between-end dialog-footer part-footer border-top">
    <div class="d-flex justify-content-end width-100p">
      <button id="sales-code-cancel-btn" class="btn btn-white pointer btn-submit ml-2"
        (click)="handleClose(isReqRefresh)">Cancel</button>

      <button id="sales-code-save-btn" class="btn btn-primary btn-submit pointer ml-2" tooltipPosition="top"
        tooltipStyleClass="tooltip-width-medium text-center"
        [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : !isValidate() ? 'Sales code name, sales code and sales group fields are required to create a sales code' : ''"
        [disabled]="!isValidate() || loaders.isSaving || !canEditClassifications" (click)="saveSalesCode()">
        <span class="font-bold">{{ isEditMode ? 'Save' : 'Create' }}</span>
        <i *ngIf="loaders.isSaving" class="fal fa-spinner rotate ml-2"></i>
      </button>
    </div>
  </div>
</div>
